import { render } from "./Select.vue?vue&type=template&id=36c98c7e&scoped=true"
import script from "./Select.vue?vue&type=script&lang=ts"
export * from "./Select.vue?vue&type=script&lang=ts"

import "./Select.vue?vue&type=style&index=0&id=36c98c7e&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-36c98c7e"

export default script